import { c as _c } from "react/compiler-runtime";
import { Stack, Tooltip } from '@mui/material';
import { ResourceType, type InventoryResource } from '@repo/api-gw-sdk';
import { useRouter } from 'next/navigation';
import { ThreatIssueIcon } from '@/components/security/threatIcons';
import { ClickableText } from '@/components/shared/clickableText';
import { CellActionsWrapper } from '@/components/table/cellActionsWrapper';
import type { AppRow, AppTable } from '@/components/table/tanstackTable';
import { hasSecurityIssue } from '../../security/securityUtils';
interface ResourceNameCellProps {
  row: AppRow<InventoryResource>;
  table: AppTable<InventoryResource>;
}
export const ResourceNameCell = t0 => {
  const $ = _c(7);
  const {
    row,
    table
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== router || $[1] !== row || $[2] !== table) {
    t1 = () => {
      if (row.original.resourceType === ResourceType.GoogleWorkspaceResource) {
        router.push(`/explorer/${encodeURIComponent(row.original.id)}`);
        return;
      }
      if (row.getIsSelected()) {
        table.resetRowSelection(true);
      } else {
        table.setRowSelection({
          [row.id]: true
        });
      }
    };
    $[0] = router;
    $[1] = row;
    $[2] = table;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleClick = t1;
  let t2;
  if ($[4] !== handleClick || $[5] !== row) {
    t2 = <BasicResourceNameCell row={row} onClick={handleClick} />;
    $[4] = handleClick;
    $[5] = row;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export const BasicResourceNameCell = t0 => {
  const $ = _c(6);
  const {
    row,
    onClick
  } = t0;
  if (!row.original.resourceName) {
    return null;
  }
  let t1;
  if ($[0] !== onClick || $[1] !== row.original) {
    t1 = hasSecurityIssue(row.original) ? <Stack direction="row" sx={{
      alignItems: "center",
      gap: "8px"
    }}><Tooltip title="Threat findings in the latest snapshot."><Stack><ThreatIssueIcon /></Stack></Tooltip><ClickableText data-testid="resource-name-cell" baseColor="var(--mui-palette-error-main)" hoverColor="var(--mui-palette-error-light)" onClick={onClick}>{row.original.resourceName}</ClickableText></Stack> : <ClickableText data-testid="resource-name-cell" onClick={onClick} sx={{
      lineHeight: "24px",
      position: "relative"
    }}>{row.original.resourceName}</ClickableText>;
    $[0] = onClick;
    $[1] = row.original;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== row.original.resourceName || $[4] !== t1) {
    t2 = <CellActionsWrapper textToCopy={row.original.resourceName}>{t1}</CellActionsWrapper>;
    $[3] = row.original.resourceName;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};